import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const NOTIFICATION_PREFERENCES_ANCHORS = {
  summary: 'notification-preferences-summary',
  manage: 'notification-preferences-manage',
} as const;

// The Notifications card of the user's own account page
// (`UserNotificationsCard.tsx`). From "Show me" on
// `content/releases/notification-preferences`.
export const notificationPreferencesTour: TourModule = {
  steps: t => [
    {
      anchor: NOTIFICATION_PREFERENCES_ANCHORS.summary,
      title: t('Your notifications at a glance'),
      body: t(
        'Each group shows how many of its notifications are on. Click a group to open it.',
      ),
      placement: 'right-start',
    },
    {
      anchor: NOTIFICATION_PREFERENCES_ANCHORS.manage,
      title: t('Choose your channels'),
      body: t(
        'Open the full list to choose email, SMS or push for each notification.',
      ),
      placement: 'left',
    },
  ],
  resolvePath: async ({ userId }) => `/users/${userId}/overview`,
};
